module.exports = __webpack_public_path__ + "static/img/fingerpost_refund_2.28da0e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_refund_2.jpg
// module id = ohYI
// module chunks = 0